<div class="bg-image flex-grow-1">
  <header class="mb-3 mb-md-5 shadow bg-light bg-opacity-50">
    <div class="py-4 container-lg">
      <h4 class="m-0 flex-wrap text-break" style="height: 38px">
        @if (!!selectedSection) {
          <a (click)="goBack()"
             class="btn btn-light text-primary">
            <i class="text-muted fa-solid fa-angle-left"></i>
            <span class="ps-1">Назад</span>
          </a>
        }
        <span class="align-middle">
          {{ !!selectedSection ? selectedSection.sectionName : 'Помощен център' }}
        </span>
      </h4>
    </div>
  </header>
  @if (!selectedSection) {
    <div class="pb-4 container-lg">
      <ul class="list-unstyled row row-cols-1 row-cols-lg-2 row-cols-xl-3">
        @for (section of sections; track section.sectionId) {
          <li class="col mb-4">
            <section class="h-100 shadow border bg-white rounded-3 overflow-hidden">
              <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
                <i [class]="section.sectionIcon" class="me-2" aria-hidden="true"></i>
                <h6 class="m-0">{{ section.sectionName }}</h6>
              </header>
              <ul class="list-group list-group-flush">
                @for (item of section.sidebarMenuItems; track item.id) {
                  <li class="list-group-item px-3 py-2">
                    <a [routerLink]="item.routerLink"
                       [queryParams]="item.queryParams"
                       [attr.aria-label]="item.title"
                       queryParamsHandling="merge"
                       class="d-flex align-items-center text-decoration-none text-dark">
                      <i class="fa-solid fa-chevron-right text-muted me-2"></i>
                      <span>{{ item.title }}</span>
                    </a>
                  </li>
                }
              </ul>
            </section>
          </li>
        }
      </ul>
    </div>
  } @else {
    <section class="mb-5 container-lg">
      <div class="row g-0 g-lg-4">
        <aside class="mb-4 col-12 col-lg-4 col-xl-3">
          <nz-sidebar-menu
            title="Меню"
            [items]="selectedSection.sidebarMenuItems"
            [selectedItem]="selectedSectionItem"
            queryParamsHandling="replace"/>
        </aside>
        <main class="col-12 col-lg-8 col-xl-9">
          <div class="shadow border bg-white rounded-3 overflow-hidden">
            <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
              <i [class]="selectedSection.sectionIcon" class="me-2" aria-hidden="true"></i>
              <h6 class="m-0">{{ selectedSectionItem?.title }}</h6>
            </header>
            <div class="p-3">
              @switch (sectionId) {
                @case (100) {
                  <nz-general-info [subsectionId]="subsectionId"/>
                }
                @case (200) {
                  <nz-login-security [subsectionId]="subsectionId"/>
                }
                @case (300) {
                  <nz-profile-settings [subsectionId]="subsectionId"/>
                }
                @case (400) {
                  <nz-ad-management [subsectionId]="subsectionId"/>
                }
                @case (500) {
                  <nz-purchases-sales [subsectionId]="subsectionId"/>
                }
                @case (600) {
                  <nz-charges-payments [subsectionId]="subsectionId"/>
                }
              }
            </div>
          </div>
        </main>
      </div>
    </section>
  }
</div>
